<!--
  Page Sections: one block per section, chosen by its layout. The block markup was
  moved unchanged from the English About Us page (same classes, data-* attributes
  and bindings); the page-only CSS it needs is in assets/css/raksme-sections.css.
-->
  <!--
    Service block: Our Services' markup for one service - the desktop row (image left
    for service_left as an 'odd' service, right for service_right as 'even') and the
    mobile row, which that page's CSS switches between.
  -->
  <ng-template #serviceBlock let-sec>
    <section class="vc_row">
      <div class="container-fluid px-0">
        <div class="row mx-0 d-md-flex flex-wrap align-items-stretch bg-dark total_service_desk rak-ourservices-container raksme-2col">
          <ng-container *ngIf="sec.layout == 'service_left'">
            <div class="lqd-column col-lg-6 col-md-6 visible-lg visible-md px-0 bg-cover" [ngStyle]="{backgroundImage: sec.bg}">
              <figure *ngIf="sec.image">
                <img class="rak-ourservice-img" [src]="sec.image" alt="" />
              </figure>
            </div>
          </ng-container>
          <div class="lqd-column col-lg-6 col-md-6 visible-lg visible-md py-6 px-md-6 d-md-flex flex-wrap align-items-center service-textblock">
            <div class="row w-100">
              <!-- Arabic Our Services offsets its desktop text column by one (pages-ar/our-services). -->
              <div class="col-md-12" [class.col-md-offset-1]="lang === 'ar'">
                <header class="fancy-title mb-5" *ngIf="sec.hasHeading">
                  <h4 class="text-white" [innerHTML]="sec.title" *ngIf="sec.title"></h4>
                  <p class="h5 font-weight-normal text-fade-white-07 mt-3 mb-0" *ngIf="sec.subtitle"><i [innerHTML]="sec.subtitle"></i></p>
                </header>
                <div class="raksme-section-desc mb-5 font-size-17 lh-175 text-fade-white-05" [innerHTML]="sec.bodyHtml" *ngIf="sec.body"></div>
                <a *ngIf="sec.hasButton" routerLink="/{{sec.btn_url}}{{langUrl}}" [attr.target]="sec.btn_new_window ? '_blank' : '_self'" class="raksme-section-btn raksme-section-btn--primary btn btn-solid semi-round btn-bordered border-thin px-2">
                  <span>
                    <span class="btn-txt">{{sec.btn_label}}</span>
                  </span>
                </a>
                <a *ngIf="sec.btn2_label && sec.btn2_form && sec.btn_url" href="javascript:void(0)" class="raksme-section-btn raksme-section-btn--secondary btn btn-default semi-round btn-bordered border-thin border-fade-red px-2 lqd-unit-animation-done" (click)="applyForm(sec)">
                  <span>
                    <span class="btn-txt">{{sec.btn2_label}}</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <ng-container *ngIf="sec.layout == 'service_right'">
            <div class="lqd-column col-lg-6 col-md-6 visible-lg visible-md px-0 bg-cover" [ngStyle]="{backgroundImage: sec.bg}">
              <figure *ngIf="sec.image">
                <img class="rak-ourservice-img" [src]="sec.image" alt="" />
              </figure>
            </div>
          </ng-container>
        </div>

        <div class="row mx-0 d-md-flex flex-wrap align-items-stretch bg-dark total_service_mob rak-ourservices-container">
          <div class="lqd-column col-sm-12 col-xs-12 visible-sm visible-xs px-0 bg-cover" [ngStyle]="{backgroundImage: sec.bg}">
            <figure *ngIf="sec.image">
              <img class="" [src]="sec.image" alt="" />
            </figure>
          </div>
          <div class="lqd-column col-sm-12 col-xs-12 visible-sm visible-xs py-6 px-md-6 d-md-flex flex-wrap align-items-center service-textblock">
            <div class="row w-100">
              <div class="col-md-12">
                <header class="fancy-title mb-5" *ngIf="sec.hasHeading">
                  <h4 class="text-white" [innerHTML]="sec.title" *ngIf="sec.title"></h4>
                  <p class="h5 font-weight-normal text-fade-white-07 mt-3 mb-0" *ngIf="sec.subtitle"><i [innerHTML]="sec.subtitle"></i></p>
                </header>
                <div class="raksme-section-desc mb-5 font-size-17 lh-175 text-fade-white-05" [innerHTML]="sec.bodyHtml" *ngIf="sec.body"></div>
                <a *ngIf="sec.hasButton" routerLink="/{{sec.btn_url}}{{langUrl}}" [attr.target]="sec.btn_new_window ? '_blank' : '_self'" class="raksme-section-btn raksme-section-btn--primary btn btn-solid semi-round btn-bordered border-thin px-2">
                  <span>
                    <span class="btn-txt">{{sec.btn_label}}</span>
                  </span>
                </a>
                <a *ngIf="sec.btn2_label && sec.btn2_form && sec.btn_url" href="javascript:void(0)" class="raksme-section-btn raksme-section-btn--secondary btn btn-default semi-round btn-bordered border-thin border-fade-red px-2 lqd-unit-animation-done" (click)="applyForm(sec)">
                  <span>
                    <span class="btn-txt">{{sec.btn2_label}}</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-template>

  <!--
    Full-width heading: title, subtitle and description, centred - the homepage
    Services / Events heading. Renders nothing when all three are empty.
    withBody: false where the block shows the description itself (standard, richtext).
  -->
  <ng-template #sectionHeading let-sec let-withBody="withBody">
    <header class="fancy-title text-center mb-6" *ngIf="sec.hasHeading || (withBody && sec.body)">
      <h2 class="mt-2 mb-2 font-weight-normal lh-1" *ngIf="sec.title"><strong [innerHTML]="sec.title"></strong></h2>
      <p class="h3 font-weight-normal mb-40 text-center mt-4" *ngIf="sec.subtitle"><i [innerHTML]="sec.subtitle"></i></p>
      <div class="raksme-section-desc font-size-18 lh-15" *ngIf="withBody && sec.body" [innerHTML]="sec.bodyHtml"></div>
    </header>
  </ng-template>

  <!-- Profile / Message button, at the bottom of the text column: the Intro button. -->
  <ng-template #textButton let-sec>
    <a *ngIf="sec.hasButton"
      routerLink="/{{sec.btn_url}}{{langUrl}}"
      [attr.target]="sec.btn_new_window ? '_blank' : '_self'"
      class="raksme-section-btn raksme-section-btn--primary btn btn-solid text-uppercase semi-round border-thin font-weight-bold mt-30"
    >
      <span class="btn-txt" [innerHTML]="sec.btnLabelHtml"></span>
    </a>
  </ng-template>

  <!--
    Message block: two columns, photo and text, top-aligned. imageLeft: the photo is
    column 1 (message_left) rather than column 2 (message). Like every two-column
    block (.raksme-2col), column 1 is on the left in English and on the right in
    Arabic (raksme-sections.css). Below 992px they stack, photo first.
    freak: the frame's mirrored offset (lqd-freak-to-left), as the originals used it.
  -->
  <ng-template #messageBlock let-sec let-imageLeft="imageLeft" let-freak="freak">
      <section class="vc_row pb-100">
        <div class="container">
          <div class="row raksme-2col raksme-message-row">
            <div class="lqd-column col-md-5 raksme-message-image" *ngIf="sec.image && imageLeft">
              <ng-container *ngTemplateOutlet="messagePhoto; context: {$implicit: sec, freak: freak}"></ng-container>
            </div>
            <div class="lqd-column raksme-message-text" [ngClass]="sec.image ? 'col-md-7' : 'col-md-12'">
              <h2 class="mt-2 mb-3 font-weight-normal" *ngIf="sec.title">
                <strong [innerHTML]="sec.title"></strong>
              </h2>
              <p class="h3 font-weight-normal mt-0 mb-30" *ngIf="sec.subtitle">
                <i [innerHTML]="sec.subtitle"></i>
              </p>

              <div class="raksme-section-desc" [innerHTML]="sec.bodyHtml" *ngIf="sec.body"></div>
              <ng-container *ngTemplateOutlet="textButton; context: {$implicit: sec}"></ng-container>
            </div>
            <div class="lqd-column col-md-5 raksme-message-image" *ngIf="sec.image && !imageLeft">
              <ng-container *ngTemplateOutlet="messagePhoto; context: {$implicit: sec, freak: freak}"></ng-container>
            </div>
          </div>
        </div>
      </section>
  </ng-template>

  <ng-template #messagePhoto let-sec let-freak="freak">
    <div class="lqd-frickin-img is-in-view photo_container" [class.lqd-freak-to-left]="freak" style="max-width: 500px">
      <div class="lqd-frickin-img-inner">
        <span class="lqd-frickin-img-bg bg-gradient-primary-br"></span>
        <div class="lqd-frickin-img-holder">
          <figure data-responsive-bg="true">
            <img [src]="sec.image" alt="" />
          </figure>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container *ngFor="let sec of items">
    <!-- One wrapper per section: it owns the vertical spacing (raksme-sections.css). -->
    <div class="raksme-page-section" [ngClass]="'raksme-page-section--' + (sec.layout || 'standard')" [ngSwitch]="sec.layout">
      <ng-container *ngSwitchCase="'service_left'"><ng-container *ngTemplateOutlet="serviceBlock; context: {$implicit: sec}"></ng-container></ng-container>
      <ng-container *ngSwitchCase="'service_right'"><ng-container *ngTemplateOutlet="serviceBlock; context: {$implicit: sec}"></ng-container></ng-container>

      <!-- intro: copy of the Intro section -->
      <section class="vc_row pb-100" *ngSwitchCase="'intro'">
        <div class="container">
          <div class="row d-flex flex-wrap align-items-center raksme-2col">
            <div class="lqd-column col-md-6 col-sm-6">
              <h2 class="mt-2 mb-3 font-weight-normal lh-1" *ngIf="sec.title">
                <strong
                  [innerHTML]="sec.title"
                ></strong>
              </h2>

              <p class="h3 font-weight-normal pr-md-7 mr-md-7 mb-40" *ngIf="sec.subtitle">
                <i [innerHTML]="sec.subtitle"></i>
              </p>

              <div
                class="raksme-section-desc font-size-18 lh-15 mb-3 pr-md-7 mr-md-7"
                [innerHTML]="sec.bodyHtml"
                *ngIf="sec.body"
              ></div>

              <a *ngIf="sec.btn_url && sec.btn_label"
                routerLink="/{{sec.btn_url}}{{langUrl}}"
                class="raksme-section-btn raksme-section-btn--primary btn btn-solid text-uppercase semi-round border-thin font-weight-bold mt-50 home_about_button"
              >
                <span
                  class="btn-txt"
                  [innerHTML]="sec.btn_label"
                ></span>
              </a>
            </div>
            <div
              class="lqd-column col-md-5 col-sm-5 col-md-offset-1 col-sm-offset-1"
            >
              <div class="lqd-parallax-images">
                <div
                  class="liquid-img-group-single"
                  data-shadow-style="4"
                  data-inview="true"
                  *ngIf="sec.images[1]"
                >
                  <div class="liquid-img-group-img-container">
                    <div
                      class="liquid-img-container-inner"
                      data-parallax="true"
                      data-parallax-from='{"translateY":78}'
                      data-parallax-to='{"translateY":-78}'
                      data-parallax-options='{"overflowHidden":false,"easing":"linear"}'
                    >
                      <figure>
                        <img
                          [src]="sec.images[1]"
                          alt="Good Design"
                        />
                      </figure>
                    </div>
                  </div>
                </div>
                <div
                  class="liquid-img-group-single w-75"
                  data-shadow-style="4"
                  data-inview="true"
                  *ngIf="sec.images[0]"
                >
                  <div class="liquid-img-group-img-container">
                    <div
                      class="liquid-img-container-inner"
                      data-parallax="true"
                      data-parallax-from='{"translateY":107}'
                      data-parallax-to='{"translateY":-134}'
                      data-parallax-options='{"overflowHidden":false,"easing":"linear"}'
                    >
                      <figure>
                        <img [src]="sec.images[0]" alt="raksme" />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" style="position: absolute; z-index: -1; bottom: 0">
        </div>
      </section>

      <!-- counters: copy of the counters section, one column per counter -->
      <section
        class="vc_row pt-50"
        *ngSwitchCase="'counters'"
      >
        <div class="container">
          <div class="row" *ngIf="sec.hasHeading || sec.body">
            <div class="lqd-column col-md-12">
              <ng-container *ngTemplateOutlet="sectionHeading; context: {$implicit: sec, withBody: true}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-3 col-xs-6 text-center text-sm-left" *ngFor="let counter of sec.counters">
              <div
                class="liquid-counter liquid-counter-default liquid-counter-lg text-center text-sm-left"
              >
                <div
                  class="liquid-counter-element text-black"
                  data-enable-counter="true"
                  [attr.data-counter-options]="counter.options"
                >
                  <!-- Arabic: the digits animate as separate spans, which lay out backwards under RTL;
                       the Arabic About Us counters force LTR on the number for the same reason. -->
                  <span [style.direction]="lang === 'ar' ? 'ltr' : null">{{counter.number}}</span>
                </div>
                <span
                  class="liquid-counter-text liquid-text-bottom text-primary"
                  [innerHTML]="counter.text"
                  *ngIf="counter.text"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- feature: copy of the Service intro section -->
      <section
        class="vc_row bg-light mt-50 bg-dark"
        *ngSwitchCase="'feature'"
      >
        <div class="container-fluid px-0">
          <div class="row mx-0 d-md-flex flex-wrap align-items-stretch raksme-2col">
            <div
              class="lqd-column col-lg-6 col-md-6 col-xs-12 py-9 d-md-flex flex-wrap align-items-center"
            >
              <div class="row w-100">
                <div class="col-md-9 col-md-offset-2">
                  <header class="fancy-title mb-5" *ngIf="sec.hasHeading">
                    <h2
                      class="text-white"
                      [innerHTML]="sec.titleHtml"
                      *ngIf="sec.title"
                    ></h2>
                    <p class="h5 font-weight-normal text-fade-white-07 mt-3 mb-0" *ngIf="sec.subtitle">
                      <i [innerHTML]="sec.subtitle"></i>
                    </p>
                  </header>
                  <div
                    class="raksme-section-desc mb-5 font-size-17 lh-175 text-fade-white-05"
                    [innerHTML]="sec.bodyHtml"
                    *ngIf="sec.body"
                  ></div>
                  <a *ngIf="sec.btn_url && sec.btn_label"
                    routerLink="/{{sec.btn_url}}{{langUrl}}"
                    class="raksme-section-btn raksme-section-btn--primary btn btn-solid text-uppercase semi-round border-thin font-weight-bold"
                  >
                    <span
                      class="btn-txt"
                      [innerHTML]="sec.btnLabelHtml"
                    ></span>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="lqd-column col-lg-6 col-md-6 col-xs-12 visible-lg visible-md px-0 bg-cover"
              data-parallax="true"
              data-parallax-options='{"parallaxBG": true}'
              [ngStyle]="{backgroundImage: sec.bg}"
            >
              <figure *ngIf="sec.image">
                <img
                  class="invisible"
                  [src]="sec.images[0]"
                  alt=""
                />
              </figure>
            </div>
          </div>
        </div>
      </section>

      <!-- profile: copy of the Chairman section -->
      <section
        class="vc_row pt-50 pb-30"
        *ngSwitchCase="'profile'"
      >
        <div class="container">
          <div class="container">
            <div class="row mb-5 raksme-2col">
              <div class="col-md-4" *ngIf="sec.image">
                <div class="liquid-img-group-container">
                  <div class="liquid-img-group-inner">
                    <div class="liquid-img-group-single">
                      <figure>
                        <img
                          [src]="sec.images[0]"
                          [attr.alt]="sec.name || ''"
                          style="max-width: 350px"
                        />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lqd-column" [ngClass]="sec.image ? 'col-md-7 col-md-offset-1' : 'col-md-12'">
                <header class="fancy-title" *ngIf="sec.hasHeading">
                  <h2 class="mt-2 mb-3 font-weight-normal" *ngIf="sec.title">
                    <strong
                      [innerHTML]="sec.title"
                    ></strong>
                  </h2>
                  <p class="h3 font-weight-normal m-0" *ngIf="sec.subtitle">
                    <i
                      [innerHTML]="sec.subtitle"
                    ></i>
                  </p>
                </header>
                <div
                  class="raksme-section-desc raksme-section-desc--p"
                  [innerHTML]="sec.bodyHtml"
                  *ngIf="sec.body"
                ></div>
                <h5 class="mt-50 mb-0" *ngIf="sec.name">
                  <strong
                    [innerHTML]="sec.name"
                  ></strong>
                </h5>
                <h6
                  class="mt-10 mb-20 font-weight-semibold text-primary"
                  [innerHTML]="sec.designation"
                  *ngIf="sec.designation"
                >
                  <i></i>
                </h6>
                <ul class="p-0" *ngIf="sec.keypoints.length">
                  <li *ngFor="let keypoint of sec.keypoints">
                    <p class="mb-2">
                      <i class="fa {{lang === 'ar' ? 'fa-angle-left' : 'fa-angle-right'}}" aria-hidden="true"></i>
                      {{keypoint}}
                    </p>
                  </li>
                </ul>
                <ng-container *ngTemplateOutlet="textButton; context: {$implicit: sec}"></ng-container>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--
        message: the Chairman's / Director's message block, as two columns: text,
        then photo. English: text left, photo right. Arabic, mirrored: photo left,
        text right (the Arabic Chairman's / Director's pages).
        message_left: photo, then text. English: photo left, text right. Arabic,
        mirrored: text left, photo right.
      -->
      <ng-container *ngSwitchCase="'message'">
        <ng-container *ngTemplateOutlet="messageBlock; context: {$implicit: sec, imageLeft: false, freak: false}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'message_left'">
        <ng-container *ngTemplateOutlet="messageBlock; context: {$implicit: sec, imageLeft: true, freak: lang !== 'ar'}"></ng-container>
      </ng-container>

      <!--
        Homepage blocks. Each is the homepage's wrapper <section> (without its
        one-page-nav id/anchor/tooltip) around a copy of the home-* component's markup.
      -->

      <!-- split: the homepage About block. images[0] front, images[1] behind -->
      <section class="vc_row" data-section-luminance="light" *ngSwitchCase="'split'">
        <section class="vc_row py-5" data-section-luminance="light">
          <div class="container">
            <div class="row d-flex flex-wrap align-items-center raksme-2col">
              <div class="lqd-column col-md-6">
                <h2 class="mt-2 mb-3 font-weight-normal lh-1" *ngIf="sec.title"><strong [innerHTML]="sec.title"></strong></h2>
                <p class="h3 font-weight-normal pr-md-7 mr-md-7 mb-40" *ngIf="sec.subtitle"><i [innerHTML]="sec.subtitle"></i></p>
                <div class="raksme-section-desc font-size-18 lh-15 mb-5 pr-md-7 mr-md-7 mb-60" [innerHTML]="sec.bodyHtml" *ngIf="sec.body"></div>
                <a *ngIf="sec.btn_url && sec.btn_label" routerLink="/{{sec.btn_url}}{{langUrl}}" [target]="sec.btn_new_window ? '_blank' : '_self'" class="raksme-section-btn raksme-section-btn--primary btn btn-solid text-uppercase semi-round border-thin font-weight-bold home_about_button">
                  <span class="btn-txt" [innerHTML]="sec.btn_label"></span>
                </a>
              </div>
              <div class="lqd-column col-md-5 col-md-offset-1">
                <div class="lqd-parallax-images">
                  <div class="liquid-img-group-single" *ngIf="sec.images[1]">
                    <div class="liquid-img-group-img-container">
                      <div class="liquid-img-container-inner">
                        <figure><img [src]="sec.images[1]" /></figure>
                      </div>
                    </div>
                  </div>
                  <div class="liquid-img-group-single w-75" *ngIf="sec.images[0]">
                    <div class="liquid-img-group-img-container">
                      <div class="liquid-img-container-inner">
                        <figure><img [src]="sec.images[0]" /></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" style="position: absolute;z-index: -1;bottom: 0;">
            </div>
          </div>
        </section>
      </section>

      <!-- split_header: the homepage Success Stories block. images[0] front, images[1] behind -->
      <section class="vc_row" data-section-luminance="light" *ngSwitchCase="'split_header'">
        <section class="vc_row pt-150 pb-50" data-section-luminance="light">
          <div class="container">
            <div class="row d-flex flex-wrap align-items-center raksme-2col">

              <div class="lqd-column col-md-6">
                <div class="row" *ngIf="sec.hasHeading">
                  <div class="lqd-column col-md-12">
                    <header class="fancy-title  mb-2">
                      <h2 class="mt-2 mb-2 font-weight-normal lh-1" *ngIf="sec.title"><strong [innerHTML]="sec.title"></strong>
                      </h2>
                      <p class="h3 font-weight-normal mb-40  mt-4" *ngIf="sec.subtitle"><i [innerHTML]="sec.subtitle"></i></p>
                    </header>
                  </div>
                </div>
                <div class="raksme-section-desc font-size-18 lh-15 mb-3 pr-md-7 mr-md-7 mb-60" [innerHTML]="sec.bodyHtml" *ngIf="sec.body"></div>
                <a *ngIf="sec.btn_url && sec.btn_label" routerLink="/{{sec.btn_url}}{{langUrl}}" class="raksme-section-btn raksme-section-btn--primary btn btn-solid text-uppercase semi-round border-thin font-weight-bold home_about_button" [target]="sec.btn_new_window ? '_blank':'_self'">
                  <span class="btn-txt" [innerHTML]="sec.btn_label"></span>
                </a>
              </div>

              <div class="lqd-column col-md-5 col-md-offset-1">
                <div class="lqd-parallax-images">
                  <div class="liquid-img-group-single" *ngIf="sec.images[1]">
                    <div class="liquid-img-group-img-container">
                      <div class="liquid-img-container-inner">
                        <figure><img [src]="sec.images[1]" /></figure>
                      </div>
                    </div>
                  </div>
                  <div class="liquid-img-group-single w-75" *ngIf="sec.images[0]">
                    <div class="liquid-img-group-img-container">
                      <div class="liquid-img-container-inner">
                        <figure><img [src]="sec.images[0]" /></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-md-12" style="position: absolute;z-index: -1;bottom: 0;">
          </div>
        </section>
      </section>

      <!-- services: the homepage services carousel; the list comes from the Services module -->
      <section class="vc_row" data-section-luminance="light" *ngSwitchCase="'services'">
        <section class="vc_row pt-150 pb-50" data-section-luminance="light">
          <div class="container">
            <div class="row">
              <div class="lqd-column col-md-12">
                <ng-container *ngTemplateOutlet="sectionHeading; context: {$implicit: sec, withBody: true}"></ng-container>
              </div>
              <div class="row">
                <div class="lqd-column col-md-12">
                  <div class="col-md-12" *ngIf="servicesFailed">
                    <raksme-error [showRetry]="true" (retry)="getServiceList()"></raksme-error>
                  </div>
                  <div class="col-md-12" *ngIf="!servicesFailed && servicesLoaded && !serviceDatas?.data?.length">
                    <raksme-empty></raksme-empty>
                  </div>
                  <div class="carousel-container carousel-shadow-active carousel-nav-left carousel-nav-md carousel-dots-style1">
                    <div class="carousel-items row"
                         data-lqd-flickity='' style="direction: ltr;">

                      <!--{"cellAlign":"left","prevNextButtons":true,"pageDots":false,"groupCells":false,"wrapAround":true,"pauseAutoPlayOnHover":false, "autoPlay": true}-->

                      <div *ngFor="let service of serviceDatas.data" class="lqd-column col-md-3 col-sm-6 carousel-item">
                        <div class="iconbox iconbox-icon-shadow iconbox-circle iconbox-xl iconbox-heading-sm px-2">
                          <div class="iconbox-icon-wrap">
                            <a routerLink="/our-services/{{service['url']}}{{langUrl}}" aria-hidden="true" tabindex="-1"><span
                              class="iconbox-icon-container bg-white"><span
                                class="iconbox-icon-hover-bg bg-gradient-primary-br"></span>
                                <img class="" [src]="service['carousal_icon']">
                            </span></a>
                          </div>
                          <div class="contents">
                            <a routerLink="/our-services/{{service['url']}}{{langUrl}}"><h3 class="font-weight-semibold " [innerHTML]="service['carousal_title']">
                            </h3></a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-md-12 text-center mt-5" *ngIf="sec.btn_url && sec.btn_label">
                  <a routerLink="/{{sec.btn_url}}{{langUrl}}" class="raksme-section-btn raksme-section-btn--primary btn btn-solid text-uppercase semi-round border-thin font-weight-bold" [target]="sec.btn_new_window ? '_blank':'_self'">
                    <span class="btn-txt">{{sec.btn_label}}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" style="position: absolute;z-index: -1;bottom: 0;">
          </div>
        </section>
      </section>

      <!--
        events: the homepage Latest Events block; the 3 latest come from the Events
        module. The event link is root-relative here: the homepage's relative
        "media-center/..." only resolves from /, and sections render on other pages.
      -->
      <section class="vc_row" data-section-luminance="light" *ngSwitchCase="'events'">
        <section class="vc_row pt-130 pb-100" data-section-luminance="light">
          <div class="container">
            <div class="row">
              <div class="lqd-column col-md-12">
                <header class="fancy-title text-center mb-6" *ngIf="sec.hasHeading || sec.body">
                  <h2 class="mt-2 mb-2 font-weight-normal lh-1" data-fittext="true" data-fittext-options='{ "compressor": 0.65, "maxFontSize": 45, "minFontSize": 45 }' *ngIf="sec.title"><strong [innerHTML]="sec.title"></strong></h2>
                  <p class="h3 font-weight-normal mb-40 text-center mt-4" *ngIf="sec.subtitle"><i [innerHTML]="sec.subtitle"></i></p>
                  <div class="raksme-section-desc font-size-18 lh-15" *ngIf="sec.body" [innerHTML]="sec.bodyHtml"></div>
                </header>
              </div>
            </div>
            <div class="row liquid-portfolio-list-row">
              <div class="col-md-12" *ngIf="eventsFailed">
                <raksme-error [showRetry]="true" (retry)="getEventList()"></raksme-error>
              </div>
              <div class="col-md-12" *ngIf="!eventsFailed && eventsLoaded && !eventItems?.length">
                <raksme-empty></raksme-empty>
              </div>

              <div class="col-md-4 col-sm-6 col-xs-12 masonry-item branding digital-design grid-hover-overlay" *ngFor="let events of eventItems">
                <article class="ld-pf-item ld-pf-dark pf-bg-shadow pf-details-visible pf-details-boxed pf-details-pull-right pf-details-pull-up-half title-size-24 pf-details-h-str pf-details-v-end post-2021 liquid-portfolio type-liquid-portfolio status-publish format-gallery has-post-thumbnail hentry post_format-post-format-gallery liquid-portfolio-category-branding liquid-portfolio-category-digital-design liquid-portfolio-category-grid-hover-overlay">
                  <div class="ld-pf-inner">
                    <div class="ld-pf-image">
                      <figure data-responsive-bg="true" data-parallax="true" data-parallax-options='{ "parallaxBG": true }'>
                        <img [src]="events['image']" alt="{{events['title']}}" />
                      </figure>
                    </div>
                    <div class="ld-pf-details py-3">
                      <div class="ld-pf-bg" style="background-color: #fff;" data-custom-animations="true" data-ca-options='{ "triggerHandler": "mouseenter", "triggerTarget": ".ld-pf-item", "triggerRelation": "closest", "offTriggerHandler": "mouseleave", "animationTarget": "this", "easing": "easeInOutCirc", "duration": 850, "offDuration": 700, "initValues": { "translateY": 0 }, "animations": { "translateY": -70 } }'>
                      </div>
                      <div class="ld-pf-details-inner" data-custom-animations="true" data-ca-options='{ "triggerHandler": "mouseenter", "triggerTarget": ".ld-pf-item", "triggerRelation": "closest", "offTriggerHandler": "mouseleave", "animationTarget": ".split-inner", "easing": "easeOutQuint", "duration": 850, "offDuration": 750, "startDelay": 280, "offDelay": 280, "delay": 60, "initValues": { "translateY": 0 }, "animations": { "translateY": -70 } }'>
                        <h3 class="ld-pf-title h4" data-split-text="true" data-split-options='{ "type": "lines" }' [innerHTML]="events['title']"></h3>
                        <p data-split-text="true" data-split-options='{ "type": "lines" }' >{{events['date']}}</p>
                      </div>
                    </div>
                    <a routerLink="/media-center/event-calendar/{{events['url_rewrite']}}{{langUrl}}" class="liquid-overlay-link" aria-hidden="true" tabindex="-1"></a>
                  </div>
                </article>
              </div>

            </div>

            <div class="row" *ngIf="sec.btn_url && sec.btn_label">
              <div class="col-md-12 text-center mt-5">
                <a routerLink="/{{sec.btn_url}}{{langUrl}}" class="raksme-section-btn raksme-section-btn--primary btn btn-solid text-uppercase semi-round border-thin font-weight-bold" [target]="sec.btn_new_window ? '_blank':'_self'">
                  <span class="btn-txt">{{sec.btn_label}}</span>
                </a>
              </div>
            </div>

          </div>
          <div class="col-md-12" style="position: absolute;z-index: -1;bottom: 0;">
          </div>
          <div class="col-md-12" style="position: absolute;z-index: -1;top: 0;">
          </div>
        </section>
      </section>

      <!-- richtext: the Terms and Conditions page's content block. Full width, centred as a whole. -->
      <section class="vc_row pb-100" *ngSwitchCase="'richtext'">
        <div class="container">
          <div class="row">
            <div class="lqd-column col-md-12 text-center">
              <ng-container *ngTemplateOutlet="sectionHeading; context: {$implicit: sec, withBody: false}"></ng-container>
              <div class="raksme-section-desc" [innerHTML]="sec.bodyHtml" *ngIf="sec.body"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- New Block (no layout): the plain block. Full width, centred as a whole; the button shows only with a label and a link. -->
      <section class="vc_row pb-60" *ngSwitchDefault>
        <div class="container">
          <div class="row">
            <div class="lqd-column col-md-12 raksme-section text-center">
              <ng-container *ngTemplateOutlet="sectionHeading; context: {$implicit: sec, withBody: false}"></ng-container>
              <img class="img-responsive center-block mb-3" *ngFor="let img of sec.images" [src]="img" alt="">
              <div class="raksme-section-desc" [innerHTML]="sec.bodyHtml" *ngIf="sec.body"></div>
              <ng-container *ngTemplateOutlet="textButton; context: {$implicit: sec}"></ng-container>
            </div>
          </div>
        </div>
      </section>

    </div>
  </ng-container>
